import React from 'react';

export const renderDataRow = (label, value) => {
    return (<div className="row data">
        <div className="label">
            {label}
        </div>
        <div className="value">
            {value}
        </div>
    </div>);
}
